<template>
  <div class="tab-container" v-if="error==null&&code==null&&state==null&&isSlackandCW">
    <b-tabs type="is-boxed" size="is-small" v-model="activeTab">
      <!-- Slack用タブ -->
      <b-tab-item>
        <template slot="header" class="header">
          <span class="tab-header">
            <span class="mdi mdi-slack mdi-24px" style="margin-left:5px;"></span>
            <span> Slack連携 </span>
          </span>
        </template>
        <!-- Slack -->
        <div class="flex block-container disp-scroll" v-if="slack.channel">
          <p style="padding: 10px;"></p>
          <div class="table-notify">
            <div class="menu-button">
              <p><b><span class="mdi mdi-slack mdi-24px" style="margin-left:5px;"></span>チーム名：{{ slack.team }}</b></p>
              <p>
                <button class="button" @click="isEditSlack=false;slack=tmp" v-if="isEditSlack"><span class="mdi mdi-undo" style="margin-right: 5px;"></span>戻る</button>
                <button class="button" @click="isEditSlack=true;tmp=slack"><span class="mdi mdi-square-edit-outline" style="margin-right: 5px;"></span>編集</button>
                <button class="button is-primary" @click="updateSlackLink(slack)"><span class="mdi mdi-content-save" style="margin-right: 5px;"></span>保存</button>
              </p>
            </div>
            <hr>
            <table style="width: 100%;" @click="isEditSlack=true;tmp=slack">
              <tr style="border-bottom: solid thin #ccc;">
                <th class="cell-class">通知種類</th>
                <th class="cell-class">チャンネル名</th>
                <th class="cell-class">通知有無</th>
              </tr>
              <tr>
                <td class="cell-class">訪問時</td>
                <td class="cell-class">
                  <input class="input is-primary background-white" v-model="slack.visit_channel_name" v-if="isEditSlack">
                  <p v-else>{{ slack.visit_channel_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="slack.is_visit" v-if="isEditSlack">{{ showSwitched(slack.is_visit) }}</b-switch>
                  <p v-else>{{ showSwitched(slack.is_visit) }}</p>
                </td>
              </tr>
              <tr>
                <td class="cell-class">アプリアイコン</td>
                <td class="cell-class">
                  <input class="input is-primary background-white" v-model="slack.icon_channel_name" v-if="isEditSlack">
                  <p v-else>{{ slack.icon_channel_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="slack.is_icon" v-if="isEditSlack">{{ showSwitched(slack.is_icon) }}</b-switch>
                  <p v-else>{{ showSwitched(slack.is_icon) }}</p>
                </td>
              </tr>
              <tr>
                <td class="cell-class">メッセージ</td>
                <td class="cell-class">
                  <input class="input is-primary background-white" v-model="slack.message_channel_name" v-if="isEditSlack">
                  <p v-else>{{ slack.message_channel_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="slack.is_message" v-if="isEditSlack">{{ showSwitched(slack.is_message) }}</b-switch>
                  <p v-else>{{ showSwitched(slack.is_message) }}</p>
                </td>
              </tr>
              <tr>
                <td class="cell-class">応募後</td>
                <td class="cell-class">
                  <input class="input is-primary background-white" v-model="slack.subscribe_channel_name" v-if="isEditSlack">
                  <p v-else>{{ slack.subscribe_channel_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="slack.is_subscribe" v-if="isEditSlack">{{ showSwitched(slack.is_subscribe) }}</b-switch>
                  <p v-else>{{ showSwitched(slack.is_subscribe) }}</p>
                </td>
              </tr>
            </table>
            <hr>
            <div style="margin-top: 200px;">
              <a class="button is-notify-button is-danger" @click="isSlackLinkDelete=true">
                <span class="mdi mdi-link-variant-off" style="margin-right: 5px;"></span>slackとの連携を解除する
              </a>
            </div>
            <b-modal width="680px" :active.sync="isSlackLinkDelete" has-modal-card>
              <header class="modal-card-head">
                <p class="modal-card-title">本当に連携を解除しますか？</p>
              </header>
              <section class="modal-card-body" :style="{ 'background-color': 'gray' }">
                <a class="button is-notify-button" @click="isSlackLinkDelete=false">
                  連携を解除しない
                </a>
                <a class="button is-notify-button" @click="deleteSlackLink()">
                  連携を解除する
                </a>
              </section>
            </b-modal>
            <hr>
          </div>
        </div>
        <div class="flex block-container disp-scroll" v-else>
          <p style="padding: 10px;"></p>
          <div class="table-notify">
            <p><b>Slackへの通知設定（共通）</b></p>
            <hr>
            <div><span class="mdi mdi-close-circle" style="color: #EB5555;"></span>現在Slackと連携しておりません。<br>下記のボタンからSlackの通知を許可してください。</div>
            <hr>
            <a href="https://slack.com/oauth/authorize?scope=incoming-webhook,chat:write:bot&client_id=304922761904.450980909159" v-if="env==='production' || env==='third'">
              <img alt="Slack連携"
                height="40" width="140"
                src="https://platform.slack-edge.com/img/add_to_slack.png"
                srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" />
            </a>
            <a href="https://slack.com/oauth/authorize?client_id=304922761904.469238422418&scope=incoming-webhook,chat:write:bot" v-else-if="env==='staging'">
              <img alt="Slack連携"
                height="40" width="140"
                src="https://platform.slack-edge.com/img/add_to_slack.png"
                srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" />
            </a>
            <div v-else>ローカル環境</div>
          </div>
        </div>
      </b-tab-item>
      <!-- ChatWork用タブ -->
      <b-tab-item>
        <template slot="header" class="header">
          <span class="tab-header">
            <img style="width:24px; height:24px;" src="@/assets/template/cw_logomark_bk.png">
            <span> Chatwork連携 </span>
            <p style="margin-top: 5px;"></p>
          </span>
        </template>
        <!-- Chatwork -->
        <div class="flex block-container disp-scroll" v-if="cw.isCWLink">
          <p style="padding: 10px;"></p>
          <div class="table-notify">
            <div class="menu-button">
              <p><b><img style="width:24px; height:24px;" src="@/assets/template/cw_logomark_bk.png">Chatwork通知設定</b></p>
              <p>
                <button class="button" @click="isEditChatwork=false;cw=tmp" v-if="isEditChatwork"><span class="mdi mdi-undo" style="margin-right: 5px;"></span>戻る</button>
                <button class="button" @click="isEditChatwork=true;tmp=cw"><span class="mdi mdi-square-edit-outline" style="margin-right: 5px;"></span>編集</button>
                <button class="button is-primary" @click="updateCWLink(cw)"><span class="mdi mdi-content-save" style="margin-right: 5px;"></span>保存</button>
              </p>
            </div>
            <hr>
            <table style="width: 100%;" @click="isEditChatwork=true;tmp=cw">
              <tr style="border-bottom: solid thin #ccc;">
                <th class="cell-class">通知種類</th>
                <th class="cell-class">ルーム名</th>
                <th class="cell-class">通知有無</th>
              </tr>
              <tr>
                <td class="cell-class">訪問時</td>
                <td class="cell-class">
                  <div class="select" v-if="isEditChatwork">
                    <select class="background-white" v-model="cw.visit_room_name" placeholder="Select" v-if="isEditChatwork">
                      <option v-for="(r, index) in cwRooms" :key="index" :value="r.name">
                        {{r.name}}
                      </option>
                    </select>
                  </div>
                  <p v-else>{{ cw.visit_room_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="cw.is_visit" v-if="isEditChatwork">{{ showSwitched(cw.is_visit) }}</b-switch>
                  <p v-else>{{ showSwitched(cw.is_visit) }}</p>
                </td>
              </tr>
              <tr>
                <td class="cell-class">アプリアイコン</td>
                <td class="cell-class">
                  <div class="select" v-if="isEditChatwork">
                    <select class="background-white" v-model="cw.icon_room_name" placeholder="Select" v-if="isEditChatwork">
                      <option v-for="(r, index) in cwRooms" :key="index" :value="r.name">
                        {{r.name}}
                      </option>
                    </select>
                  </div>
                  <p v-else>{{ cw.icon_room_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="cw.is_icon" v-if="isEditChatwork">{{ showSwitched(cw.is_icon) }}</b-switch>
                  <p v-else>{{ showSwitched(cw.is_icon) }}</p>
                </td>
              </tr>
              <tr>
                <td class="cell-class">メッセージ</td>
                <td class="cell-class">
                  <div class="select" v-if="isEditChatwork">
                    <select class="background-white" v-model="cw.message_room_name" placeholder="Select" v-if="isEditChatwork">
                      <option v-for="(r, index) in cwRooms" :key="index" :value="r.name">
                        {{r.name}}
                      </option>
                    </select>
                  </div>
                  <p v-else>{{ cw.message_room_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="cw.is_message" v-if="isEditChatwork">{{ showSwitched(cw.is_message) }}</b-switch>
                  <p v-else>{{ showSwitched(cw.is_message) }}</p>
                </td>
              </tr>
              <tr>
                <td class="cell-class">応募後</td>
                <td class="cell-class">
                  <div class="select" v-if="isEditChatwork">
                    <select class="background-white" v-model="cw.subscribe_room_name" placeholder="Select" v-if="isEditChatwork">
                      <option v-for="(r, index) in cwRooms" :key="index" :value="r.name">
                        {{r.name}}
                      </option>
                    </select>
                  </div>
                  <p v-else>{{ cw.subscribe_room_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="cw.is_subscribe" v-if="isEditChatwork">{{ showSwitched(cw.is_subscribe) }}</b-switch>
                  <p v-else>{{ showSwitched(cw.is_subscribe) }}</p>
                </td>
              </tr>
            </table>
            <hr>
            <div style="margin-top: 180px;">
              <a class="button is-notify-button is-danger" @click="isChatworkLinkDelete=true">
                <span class="mdi mdi-link-variant-off" style="margin-right: 5px;"></span>Chatworkとの連携を解除する
              </a>
            </div>
            <hr>
            <b-modal width="680px" :active.sync="isChatworkLinkDelete" has-modal-card>
              <header class="modal-card-head">
                  <p class="modal-card-title">本当に連携を解除しますか？</p>
              </header>
              <section class="modal-card-body" :style="{ 'background-color': 'gray' }">
                <a class="button is-notify-button" @click="isChatworkLinkDelete=false">
                  連携を解除しない
                </a>
                <a class="button is-notify-button" @click="deleteChatworkLink()">
                  連携を解除する
                </a>
              </section>
            </b-modal>
          </div>
        </div>
        <div class="flex block-container disp-scroll" v-else>
          <p style="padding: 10px;"></p>
          <div class="table-notify">
            <p><b>Chatworkへの通知設定</b></p>
            <hr>
            <div><span class="mdi mdi-close-circle" style="color: #EB5555;"></span>現在Chatworkと連携しておりません。<br>下記のボタンからChatworkの通知を許可してください。</div>
            <hr>
            <div v-if="env==='production'">
              <a class="button is-notify-button" href="https://www.chatwork.com/packages/oauth2/login.php?response_type=code&redirect_uri=https://hr-monster.io/dashboard/setting/other_api&client_id=4XD7KDWkpgJOP&state=accessndr&scope=rooms.all:read_write%20offline_access">
                <span class="mdi mdi-link-variant"></span>Chatworkと連携する
              </a>
            </div>
            <div v-else-if="env==='third'">
              <a class="button is-notify-button" href="https://www.chatwork.com/packages/oauth2/login.php?response_type=code&redirect_uri=https://robottte.hr-monster.io/dashboard/setting/other_api&client_id=eQpjMVmxAK058&state=accessndr&scope=rooms.all:read_write%20offline_access">
                <span class="mdi mdi-link-variant"></span>Chatworkと連携する
              </a>
            </div>
            <div v-else-if="env==='staging'">
              <a class="button is-notify-button" href="https://www.chatwork.com/packages/oauth2/login.php?response_type=code&redirect_uri=https://w2.ndr-staging.work/dashboard/setting/other_api&client_id=eQpjMVmxAK058&state=accessndr&scope=rooms.all:read_write%20offline_access">
                <span class="mdi mdi-link-variant"></span>Chatworkと連携する
              </a>
            </div>
            <div v-else>ローカル環境</div>
          </div>
        </div>
      </b-tab-item>
      <!-- WowTalk用タブ -->
      <!-- <b-tab-item>
        <template slot="header" class="header">
          <span class="mdi mdi-link mdi-24px" style="margin-left:5px;"></span>
          <span> WowTalk連携 </span>
        </template> -->
        <!-- WowTalk -->
        <!-- <div class="flex block-container disp-scroll">
          <p style="padding: 10px;"></p>
          <div class="table-notify">
            <div class="menu-button">
              <p><b>WowTalkと連携する場合は、管理画面よりOPEN APIキーを取得してください。</b></p>
              <p v-if="isWowTalk">
                <button class="button" @click="isEditWowTalk=false;wt=tmp" v-if="isEditWowTalk"><span class="mdi mdi-undo" style="margin-right: 5px;"></span>戻る</button>
                <button class="button" @click="isEditWowTalk=true;tmp=wt"><span class="mdi mdi-square-edit-outline" style="margin-right: 5px;"></span>編集</button>
                <button class="button is-primary" @click="updateWTLink(wt)"><span class="mdi mdi-content-save" style="margin-right: 5px;"></span>保存</button>
              </p>
            </div>
            <hr>
            <div class="api-key-input">
              <p style="width: 50%; text-align: right; padding-right: 15px;">OPEN APIキー</p><input v-model="wt.api_key" class="input" style="background-color: white !important;"/>
            </div>
            <div class="api-key-input">
              <p style="width: 50%; text-align: right; padding-right: 15px;">会社ID</p><input v-model="wt.company" class="input" style="background-color: white !important;"/>
            </div>
            <div class="api-key-input">
              <p style="width: 50%; text-align: right; padding-right: 15px;">アカウントID</p><input v-model="wt.account_id" class="input" style="background-color: white !important;"/>
            </div>
            <div class="api-key-input">
              <p style="width: 50%; text-align: right; padding-right: 15px;">パスワード</p><input type="password" v-model="wt.password" class="input" style="background-color: white !important;"/>
            </div>
            <div>
              <button @click="$store.dispatch('auth/postWTLink', wt)" class="button is-primary" v-if="!isWowTalk">WowTalk連携を開始する</button>
            </div>
            <table style="width: 100%;" @click="isEditWowTalk=true;tmp=wt" v-if="isWowTalk">
              <tr style="border-bottom: solid thin #ccc;">
                <th class="cell-class">通知種類</th>
                <th class="cell-class">部門名</th>
                <th class="cell-class">通知有無</th>
              </tr>
              <tr>
                <td class="cell-class">応募後</td>
                <td class="cell-class">
                  <input class="input is-primary is-fullwidth background-white" v-model="wt.subscribe_room_name" v-if="isEditWowTalk">
                  <p v-else>{{ wt.subscribe_room_name }}</p>
                </td>
                <td class="cell-class">
                  <b-switch v-model="wt.is_subscribe" v-if="isEditWowTalk">{{ showSwitched(wt.is_subscribe) }}</b-switch>
                  <p v-else>{{ showSwitched(wt.is_subscribe) }}</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </b-tab-item> -->
      <!-- GoogleDrive用タブ -->
      <b-tab-item>
        <template slot="header" class="header">
          <span class="tab-header">
            <span class="mdi mdi-google-drive mdi-24px" style="margin-left:5px;"></span>
            <span> GoogleDrive連携 </span>
            <p style="margin-top: 5px;"></p>
          </span>
        </template>
        <!-- GoogleDrive -->
        <div class="flex block-container disp-scroll">
          <p style="padding: 10px;"></p>
          <div class="table-notify">
            <div class="menu-button">
              <p><b><span class="mdi mdi-google-drive mdi-24px" style="margin-left:5px;"></span>GoogleDrive連携設定</b></p>
              <p>
                <button class="button is-primary" @click="GoogleDriveAuth" v-if="!isGoogleDriveAuth">連携</button>
                <button class="button is-danger" @click="GoogleDriveRevoke" v-if="isGoogleDriveAuth">解除</button>
              </p>
            </div>
            <p style="text-align: left; padding-left: 16px;">
              GoogleDriveと連携することで、ロボからのファイルアップロードを<br>
              GoogleDriveへと直接保存することが可能になります。
            </p>
            <hr>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item>
        <template slot="header" class="header">
          <span class="tab-header">
            <img style="height: 12px;" src="@/assets/template/LOA_logo_1_black_JP.svg">
            <span> 連携 </span>
            <p style="margin-top: 5px;"></p>
          </span>
        </template>
        <LineApiSetting></LineApiSetting>
      </b-tab-item>
    </b-tabs>
  </div>
  <div class="tab-container" v-else-if="error!=null">
    <p style="padding-top: 30%;">
      <span class="mdi mdi-exclamation mdi-48px" style="color: red;"></span>
      エラーが発生しました。下記のボタンから再読み込みしてください。
    </p>
    <a href="/dashboard/setting/other_api" class="button is-primary">再読み込み</a>
  </div>
  <div class="tab-container" v-else-if="code==null&&state==null&&!isSlackandCW">
    <p style="padding-top: 30%;">
      <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
      外部APIを探索中です。
    </p>
  </div>
  <div class="tab-container" v-else>
    <p style="padding-top: 30%;">
      <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
      リダイレクト中です。しばらくお待ちください。
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import getParam from '../../../functions/getParam'
import LineApiSetting from './OtherAPIs/LineApiSetting.vue'
export default {
  name: 'NotifySetting',
  componentName: 'NotifySetting',
  computed: {
    ...mapState('auth', ['user', 'slack', 'cw', 'cwRooms', 'isSlackandCW', 'wt', 'isWowTalk', 'isGoogleDriveAuth'])
  },
  components: {
    LineApiSetting
  },
  data () {
    return {
      activeTab: 0,
      on: true,
      sec: '10',
      env: process.env.NODE_ENV,
      isSlackLinkDelete: false,
      isChatworkLinkDelete: false,
      isSlackView: true,
      isChatworkView: false,
      isEditChatwork: false,
      isEditSlack: false,
      isEditWowTalk: false,
      selected: null,
      code: getParam('code'),
      state: getParam('state'),
      error: getParam('error'),
      tmp: {},
      clock: [
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00'
      ]
    }
  },
  mounted () {
    // Googleドライブ連携エラーまたはキャンセルメッセージ表示
    if (this.$route.query.error_google_drive_auth || this.$route.query.cancel_google_drive_auth) {
      if (this.$route.query.error_google_drive_auth) {
        alert('Googleドライブとの連携でエラーが発生しました。')
      } else if (this.$route.query.cancel_google_drive_auth) {
        alert('Googleドライブとの連携をキャンセルしました。')
      }
      // アラート表示のためのクエリパラメータを削除したURLにする
      this.$router.push(this.$route.path)
    }
  },
  methods: {
    deleteSlackLink () {
      console.debug('*** Start *** deleteSlackLink')
      this.$store.dispatch('auth/deleteSlackLink')
      this.isSlackLinkDelete = false
      console.debug('*** End *** deleteSlackLink')
    },
    deleteChatworkLink () {
      console.debug('*** Start *** deleteChatworkLink')
      this.$store.dispatch('auth/deleteCWLink')
      this.isChatworkLinkDelete = false
      console.debug('*** End *** deleteChatworkLink')
    },
    showSwitched (flg) {
      console.debug('*** Start *** showSwitched')
      console.debug('flg: ' + JSON.stringify(flg))
      if (flg) return 'ON'
      else return 'OFF'
    },
    updateSlackLink (slack) {
      console.debug('*** Start *** updateSlackLink')
      console.debug('slack: ' + JSON.stringify(slack))
      this.$store.dispatch('auth/updateSlack', slack)
      this.isEditSlack = false
      console.debug('*** End *** updateSlackLink')
    },
    updateCWLink (cw) {
      console.debug('*** Start *** updateCWLink')
      console.debug('cw: ' + cw)
      var cwData = cw
      for (var i in this.cwRooms) {
        if (cw.visit_room_name === this.cwRooms[i].name) cwData.visit_room_id = this.cwRooms[i].room_id
        if (cw.icon_room_name === this.cwRooms[i].name) cwData.icon_room_id = this.cwRooms[i].room_id
        if (cw.message_room_name === this.cwRooms[i].name) cwData.message_room_id = this.cwRooms[i].room_id
        if (cw.subscribe_room_name === this.cwRooms[i].name) cwData.subscribe_room_id = this.cwRooms[i].room_id
      }
      this.$store.dispatch('auth/updateCW', cwData)
      this.isEditChatwork = false
      console.debug('*** End *** updateCWLink')
    },
    updateWTLink (wt) {
      console.debug('*** Start *** updateWTLink')
      console.debug('wt: ' + JSON.stringify(wt))
      this.$store.dispatch('auth/WTPut', wt)
      this.isEditWowTalk = false
      console.debug('*** End *** updateWTLink')
    },
    GoogleDriveAuth () {
      this.$store.dispatch('auth/googleDriveAuth', {email: this.user.email, username: this.user.username})
    },
    GoogleDriveRevoke () {
      this.$store.dispatch('auth/googleDriveAuthRevoke')
    }
  }
}
</script>

<style scoped>
.flex{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.tabs-list {
  padding: 15px;
  color: #F2F2F2;
}
.tabs-list:hover {
  color: #F2DEF2;
}
.tab-header {
  display: flex;
  height: 36px;
  align-items: center;
}
.tab-container {
  margin: 0;
  height: calc(100vh - 80px);
}
.fade-enter-active {
  transition: opacity .5s, transform .5s;
}
.fade-enter {
  opacity: 0;
  transform: translateY(0px);
}
.setting-box {
  justify-content: space-evenly;
}
.block-container {
  height: calc(100vh - 160px);
  padding: 20px;
  width: 100%;
  flex-flow: column nowrap;
}

.is-notify-button {
  width: 240px;
}

.table-notify {
  background: #FEFEFE;
  padding: 25px;
  border-radius: 5px;
}

.menu-button {
  display: flex;
  justify-content: space-between;
}

.cell-class {
  padding: 0.5em;
}

.background-white {
  background: white !important;
}

.api-key-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/NotifySetting.vue